'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = ['onClick', 'onChange', 'style', 'className', 'contentEditable'];